// extracted by mini-css-extract-plugin
module.exports = {"container":"flash-message-stack_container__uxe5C","itemClassName":"flash-message-stack_itemClassName__HpvtH"};